import styled from 'styled-components';

export const TextArea = styled.textarea`
  width: 100%;
  height: ${(props) => props.height || '5.5rem'};
  border-radius: 6px;
  border: solid 1px ${(props) => props.theme.color.pinkishGrey};
  resize: none;
  padding: 0.625rem 1rem 1.25rem;
  outline: none;
  font-size: 0.75rem;

  ::placeholder {
    color: ${(props) => props.theme.color.pinkishGrey};
  }
`;
